import { createContext } from 'react';

export interface ConsentContextValue {
    /** False until the visitor has answered the banner. */
    decided: boolean;
    analytics: boolean;
    /** The banner is showing: the visitor hasn't answered, or reopened it from the footer. */
    bannerOpen: boolean;
    accept: () => void;
    reject: () => void;
    /** Footer entry point. Withdrawing consent has to be as easy as giving it. */
    reopen: () => void;
    /** Closes a reopened banner, keeping the current choice. */
    close: () => void;
}

export const ConsentContext = createContext<ConsentContextValue | null>(null);
